export const N76 = {
    "columns": 4,
    "rows": 3,
    "visual": {
      "id": 1,
      "type": "bar2",
      "title": "Top Principals",
      "colorTheme": 'colorTheme3',
      "orientation": "horizontal",
      "xAxis": "Sales",
      "yAxis": "",
      "binding": {
        "data": {
          "series": [
            {
              "name": 'Sales',
              "value": 'ActualSales',
              "type": 'column'
            }
          ],
          "title": "DistributorCode",
          "endpoint": "N76",
          "parameters": [
            { "key": "FromMonth", "value": "" },
            { "key": "FromYear", "value": "" },
            { "key": "ToMonth", "value": "" },
            { "key": "ToYear", "value": "" },
            { "key": "ConfigTypeCode", "value": "" }
          ]
        },
        "context": {
          "point": {
            "onClick": { }
          }
        }
      }
    }
  }